var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge badge-light"},[_vm._v("\n  "+_vm._s(_vm.language.code)+"-"+_vm._s(_vm.language.region.code)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }